
import UMUM from "../../library/umum.js";
export default {
   data() {
      return {
         UMUM: UMUM,


         form: {
            id: null,
            nama_ruangan: '',
            nama_pj: ''
         },

         mdl_add: false,
         mdl_edit: false,
         mdl_hapus: false,
         btn_add: false,
         btn_edit: false,
         file_path: this.$store.state.url.URL_APP + "uploads/",

         list_data: [],
         jml_data: 0,
         total_data: 0,
         page_first: 1,
         page_last: 0,
         page_limit: 10,
         cari_value: '',



         mdl_password: false,
         dataku: {
            username: '',
            password: '',
            confirmPassword: ''
         },
         errorMessage: '',

         mdl_lihat: false,
         lihatData: {
            nama_lengkap: '',
            nip: '',
            nomor_induk_profesi: '',
            jabatan_fungsional: '',
            no_str: '',
            masa_berlaku_str: '',
            file_str: '',
            email: '',
            no_hp: '',
            tempat_kerja: '',
            alamat_praktik: '',
            username: '',
         },
      }
   },
   methods: {

      getView() {
         const body = {
            page_limit: this.page_limit,
            data_ke: (this.page_first - 1) * this.page_limit,
            cari_value: this.cari_value,
         };

         fetch(this.$store.state.url.REGIS_MEDIS + "getview", {
            method: "POST",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(body)
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_data = res_data.data;
               this.jml_data = res_data.jml_data;
               this.total_data = res_data.total_data;
               this.page_last = Math.ceil(this.total_data / this.page_limit);
            })
            .catch(err => {
               console.error("Error fetching data:", err);
               this.$q.notify({ type: "negative", message: "Gagal mengambil data tenaga medis" });
            });
      },


      async addData() {
         try {
            // Validasi sisi-klien
            if (!this.form.nama_ruangan || !this.form.nama_pj || !this.dataku.username || !this.dataku.password || !this.dataku.confirmPassword) {
               this.$q.notify({ type: 'negative', message: 'Semua field wajib diisi!' });
               return;
            }

            if (this.dataku.password !== this.dataku.confirmPassword) {
               this.$q.notify({ type: 'negative', message: 'Password dan konfirmasi tidak sama!' });
               return;
            }

            if (this.dataku.password.length < 6) {
               this.$q.notify({ type: 'negative', message: 'Password minimal 6 karakter!' });
               return;
            }

            if (this.dataku.username.length < 4) {
               this.$q.notify({ type: 'negative', message: 'Username minimal 4 karakter!' });
               return;
            }

            this.btn_add = true;

            // Payload sebagai JSON (bukan FormData)
            const payload = {
               nama_ruangan: this.form.nama_ruangan,
               nama_pj: this.form.nama_pj,
               username: this.dataku.username,
               password: this.dataku.password
            };

            // NOTE: ganti "addTenagaMedis" ke "addRuangan" jika backend Anda pakai nama route itu
            const response = await fetch(this.$store.state.url.REGIS_MEDIS + "addTenagaMedis", {
               method: 'POST',
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (response.ok && result.success) {
               this.$q.notify({ type: 'positive', message: result.message || 'Registrasi berhasil!' });
               this.resetForm();
               this.mdl_add = false;
               this.getView();
               this.$emit('data-added');
            } else {
               throw new Error(result.message || 'Gagal registrasi');
            }
         } catch (error) {
            console.error('Error adding data:', error);
            this.$q.notify({ type: 'negative', message: error.message || 'Gagal menambah data!' });
         } finally {
            this.btn_add = false;
         }
      },

      resetForm() {
         this.form = {
            id: null,
            nama_ruangan: '',
            nama_pj: ''
         };
         this.dataku = {
            username: '',
            password: '',
            confirmPassword: ''
         };
         this.errorMessage = '';
      },

      async editData() {
  this.errorMessage = '';
  this.btn_edit = true;

  try {
    // Validasi wajib
    if (!this.form.nama_ruangan || !this.form.nama_pj) {
      throw new Error('Nama Ruangan dan Nama PJ wajib diisi!');
    }

    // Jika username diisi, minimal 4 karakter
    if (this.dataku.username && this.dataku.username.length < 4) {
      throw new Error('Username minimal 4 karakter!');
    }

    // Jika user mengisi password, lakukan validasi password & konfirmasi
    let wantChangePassword = false;
    if (this.dataku.password || this.dataku.confirmPassword) {
      wantChangePassword = true;
      if (this.dataku.password.length < 6) {
        throw new Error('Password minimal 6 karakter!');
      }
      if (this.dataku.password !== this.dataku.confirmPassword) {
        throw new Error('Password dan konfirmasi tidak sama!');
      }
    }

    // Siapkan payload JSON
    const payload = {
      id: this.form.id || '',
      // users_id perlu diset dari editModal ketika dipanggil
      users_id: this.dataku.users_id || '',
      nama_ruangan: this.form.nama_ruangan,
      nama_pj: this.form.nama_pj,
      username: this.dataku.username || ''
    };

    if (wantChangePassword) {
      payload.password = this.dataku.password;
    }

    // NOTE: ganti "EditTenagaMedis" ke "EditRuangan" jika backend Anda pakai nama route itu
    const response = await fetch(this.$store.state.url.REGIS_MEDIS + "EditTenagaMedis", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (response.ok && result.success) {
      this.$q.notify({ type: 'positive', message: result.message || 'Data berhasil diupdate!' });
      this.mdl_edit = false;
      this.resetForm();
      this.getView();
    } else {
      throw new Error(result.message || 'Gagal mengupdate data!');
    }
  } catch (err) {
    console.error('Error editData:', err);
    this.errorMessage = err.message || 'Terjadi kesalahan saat update';
    this.$q.notify({ type: 'negative', message: this.errorMessage });
  } finally {
    this.btn_edit = false;
  }
},
      editModal(data) {
         this.form = {
            id: data.id || null,
            nama_ruangan: data.nama_ruangan || '',
            nama_pj: data.nama_pj || ''
         };

         this.dataku = {
            users_id: data.users_id || null,
            username: data.username || '',
            password: '',
            confirmPassword: ''
         };

         this.errorMessage = '';
         this.mdl_edit = true;
      },


      async hapusData() {
         this.btn_hapus = true;
         try {
            const response = await fetch(this.$store.state.url.REGIS_MEDIS + "removeTenagaMedis", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({
                  id: this.form.id,           // id tenaga medis
                  users_id: this.form.users_id // id user terkait
               })
            });

            const res_data = await response.json();
            this.btn_hapus = false;

            if (response.ok && res_data.success) {
               this.mdl_hapus = false;
               this.getView(); // refresh data
               this.$q.notify({ type: 'positive', message: res_data.message || 'Data berhasil dihapus' });
            } else {
               this.$q.notify({ type: 'negative', message: res_data.message || 'Gagal menghapus data' });
            }
         } catch (error) {
            this.btn_hapus = false;
            this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menghapus data' });
            console.error('Error hapus data:', error);
         }
      },

      async editDataPassword() {
         this.errorMessage = '';

         // Validasi input password
         if (!this.dataku.password || !this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password wajib diisi!";
            return;
         }

         if (this.dataku.password.length < 6) {
            this.errorMessage = "Password minimal 6 karakter!";
            return;
         }

         if (this.dataku.password !== this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password tidak sama!";
            return;
         }

         try {
            const res = await fetch(this.$store.state.url.REGIS_MEDIS + "editPassword", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({
                  users_id: this.dataku.users_id,
                  password: this.dataku.password
               })
            });

            const data = await res.json();

            if (res.ok && data.success) {
               this.$q.notify({ type: "positive", message: data.message || "Password berhasil diubah!" });
               this.mdl_password = false;
               // Reset password fields
               this.dataku.password = '';
               this.dataku.confirmPassword = '';
            } else {
               this.errorMessage = data.message || "Gagal mengubah password!";
            }
         } catch (error) {
            console.error(error);
            this.errorMessage = "Terjadi kesalahan saat mengubah password.";
         }
      },


      async editDataPassword() {
         this.errorMessage = '';

         // validasi password
         if (!this.dataku.password || !this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password wajib diisi!";
            return;
         }

         if (this.dataku.password !== this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password tidak sama!";
            return;
         }

         try {
            const res = await fetch(this.$store.state.url.REGIS_MEDIS + "editPasswordTenagaMedis", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({
                  users_id: this.dataku.users_id,
                  password: this.dataku.password
               })
            });

            const data = await res.json();

            if (data.success) {
               this.$q.notify({ type: "positive", message: "Password berhasil diubah!" });
               this.mdl_password = false;
            } else {
               this.errorMessage = data.message || "Gagal mengubah password!";
            }
         } catch (error) {
            console.error(error);
            this.errorMessage = "Terjadi kesalahan saat mengubah password.";
         }
      },


      indexing(idx) {
         return ((this.page_first - 1) * this.page_limit) + idx;
      },

      selectData(data) {
         this.dataku = {
            users_id: data.users_id,
            password: '',
            confirmPassword: ''
         };
         this.errorMessage = '';
         this.form = {
            ...data,
            users_id: data.users_id,
            id: data.id
         };
         this.lihatData = {
            nama_lengkap: data.nama_lengkap || '',
            nip: data.nip || '',
            nomor_induk_profesi: data.nomor_induk_profesi || '',
            jabatan_fungsional: data.jabatan_fungsional || '',
            no_str: data.no_str || '',
            masa_berlaku_str: data.masa_berlaku_str || '',
            file_str: data.file_str || '',
            email: data.email || '',
            no_hp: data.no_hp || '',
            tempat_kerja: data.tempat_kerja || '',
            alamat_praktik: data.alamat_praktik || '',
            username: data.username || '',
            users_id: data.users_id || '',
            id: data.id || '',
         };
      },
      // Method untuk membuka file STR di tab baru
      openFileSTR() {
         if (this.lihatData.file_str) {
            const url = this.file_path + this.lihatData.file_str;
            window.open(url, '_blank');
         } else {
            this.$q.notify({ type: 'negative', message: 'File STR tidak tersedia' });
         }
      },

      normalizeDate(dateStr) {
         if (!dateStr || dateStr === '') return '';
         if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
         if (dateStr.includes('T')) return dateStr.split('T')[0];
         return '';
      },



      cari_data() { this.page_first = 1; this.getView(); }
   },
   mounted() {
      this.getView();
   }
}
